import {writable} from 'svelte/store';

const data = {items: []};
const gallery = writable(data);

gallery.render = () => {
	data.items = window.renderer.gallery();
	gallery.set(data);
};

gallery.clear = () => {
	data.items = [];
	gallery.set(data);
};

gallery.main = () => {
	for (let item of data.items)
		if (item.view.main)
			return item;
};

export default gallery;